(function() { module.exports = this["NeoGames"]; }());


/*****************
 ** WEBPACK FOOTER
 ** external "NeoGames"
 ** module id = 4
 ** module chunks = 0
 **/